/**
 * Readable message from axios/fetch-style errors for user-facing toasts.
 * @param {unknown} err
 * @param {string} [fallbackMessage] i18n or app default when nothing useful is extracted
 */
export function normalizeApiErrorMessage(err, fallbackMessage) {
  const fallback =
    typeof fallbackMessage === 'string' && fallbackMessage.trim()
      ? fallbackMessage.trim()
      : 'Something went wrong. Please try again.';
  const data = err?.response?.data;
  if (data && typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }
  if (typeof data === 'string' && data.trim()) {
    const s = data.trim().replace(/\s+/g, ' ');
    return s.length > 220 ? `${s.slice(0, 220)}…` : s;
  }
  if (!err?.response && typeof err?.message === 'string' && err.message.trim()) {
    const m = err.message.trim();
    if (/network/i.test(m) || err.code === 'ECONNABORTED' || err.code === 'ERR_NETWORK') {
      return 'Network error. Check your connection and try again.';
    }
    return m;
  }
  if (typeof err?.message === 'string' && err.message.trim()) {
    return err.message.trim();
  }
  return fallback;
}
